// libraries
import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";

//component
import AppButton from "components/app-button";
import pathnames from "routes/pathnames";

import AppReactTable from "components/app-react-table";
import { IoClose, IoTrashOutline, IoCheckmark } from "react-icons/io5";
import { BiEditAlt } from "react-icons/bi";
// import 'react-calendar/dist/Calendar.css';
// commons
import CONSTANSTS from "common/constansts";
import AppCustomToast, { PageContext } from "components/app-custom-toast";

const PageMerchantView = () => {
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  const history = useHistory();
  const { merchantId } = useParams();
  const [accessMerchantAddress, setAccessMerchantAddress] = useState({
    list_merchant_address: false,
    create_merchant_address: false,
    delete_merchant_address: false,
    update_merchant_address: false,
  });

  useEffect(() => {
    let dbMerchantAccess = null;
    dbMerchantAccess = JSON.parse(localStorage.getItem("accessMatrix"));

    if (dbMerchantAccess) {
      setAccessMerchantAddress(
        dbMerchantAccess.accessMatrix.Merchant_Discovery
      );
    }
  }, []);

  const back = async () => {
    history.push(pathnames.pageMerchantDiscoverList);
  };

  const [tabCol1, setTabCol1] = useState("tab-selected");
  const [firstTab, setFirstTab] = useState("display");
  const tabClicked = (e) => {
    var tabNo = e;
    if (tabNo === "1") {
      setTabCol1("tab-selected");
      setFirstTab("display");
    }
  };

  // secondTab //

  const [tableSearchFilter] = useState({
    // insert the key value requested by BE here
    pageNo: 1,
    pageSize: 50,
    sortBy: "id",
    sortDir: "ASCENDING",
    dateRangeType: null,
    dateFrom: "string",
    dateTo: "string",
    keyword: "",
  });

  const merchantAddressTableColumn = [
    {
      id: "name",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Shop Name</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "name",
      accessor: "name",
      minWidth: 200,
    },
    {
      id: "address1",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Address 1</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "address1",
      accessor: "address1",
      minWidth: 200,
    },
    {
      id: "address2",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Address 2</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "address2",
      accessor: "address2",
      minWidth: 200,
    },
    {
      id: "postcode",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Postcode</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "postcode",
      accessor: "postcode",
      minWidth: 200,
    },
    {
      id: "state",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">State</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "state",
      accessor: "state",
      minWidth: 200,
    },
    {
      id: "Status",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Status</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "status",
      accessor: "status",
      minWidth: 200,
    },
    {
      id: "button",
      Header: () => <span className="react-table__headers-title">Action</span>,
      Cell: (row) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            {row.row.original.status == "PENDING_CREATE" ||
            row.row.original.status == "PENDING_DELETE"
              ? accessMerchantAddress.create_merchant_discovery && (
                  <>
                    <button
                      onClick={() => [
                        merchantDiscoveryAddressesApproval(row.row.original, true),
                      ]}
                      className="react-table__search-button"
                      style={{ marginRight: "3px" }}
                    >
                      <IoCheckmark size={24} />
                    </button>
                    <button
                      onClick={() => [
                        merchantDiscoveryAddressesApproval(row.row.original, false),
                      ]}
                      className="react-table__search-button"
                    >
                      <IoClose size={24} />
                    </button>
                  </>
                )
              : row.row.original.status == "ACTIVE"
              ? accessMerchantAddress.create_merchant_address && (
                  <>
                    <button
                      onClick={() => [
                        setPopupEdit(true),
                        setMerchantId(row.row.original),
                      ]}
                      className="react-table__search-button"
                      style={{ marginRight: "3px" }}
                    >
                      <BiEditAlt size={24} />
                    </button>
                  </>
                )
              : null}
            {row.row.original.status == "ACTIVE"
              ? accessMerchantAddress.delete_merchant_address && (
                  <>
                    <button
                      onClick={() => [
                        setCancelPopUp2(true),
                        setMerchantId(row.row.original),
                      ]}
                      className="react-table__search-button"
                    >
                      <IoTrashOutline size={24} />
                    </button>
                  </>
                )
              : null}
            <PopupRemoveMerchantAddress trigger={cancelPopUp2}>
              <div className="pop-up-message">
                <p>Are you sure you want to remove this shop address?</p>
              </div>
            </PopupRemoveMerchantAddress>
          </div>
        );
      },
      minWidth: 90,
      width: 90,
    },
  ];

  const headerArrowRotate = (active) => {
    // current column header arrow icon will rotate depending on ascending order or descending order (tableSearchFilter.sortDir)
    const classNames = ["react-table__icon-wrapper"];
    if (active && tableSearchFilter.sortDir === "DESCENDING")
      classNames.push("react-table__icon-wrapper-down");
    if (active) classNames.push("react-table__icon-wrapper--show");
    return classNames.join(" ");
  };

  const [merchantAddressTable, setMerchantAddressTable] = useState({
    pageNo: 1,
    pageSize: 50,
    sortDir: "ASCENDING",
    sortBy: "id",
  });

  const [merchantIds, setMerchantId] = useState("");
  const [cancelPopUp2, setCancelPopUp2] = useState(false);
  const [PopupEdit, setPopupEdit] = useState(false);
  const [merchantAddressList, setMerchantAddressList] = useState(undefined);
  const [stateList, setStateList] = useState(undefined);
  const [merchantName, setMerchantName] = useState("");
  const [autoExpanded, setExpanded] = useState({});

  function PopupRemoveMerchantAddress(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              className="pop-up-button"
              style={{ marginRight: "10px" }}
              onClick={() => removeMerchantAddress(merchantIds)}
            >
              OK
            </button>
            <button
              className="pop-up-button"
              style={{ marginLeft: "10px" }}
              onClick={() => [setCancelPopUp2(false)]}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  const removeMerchantAddress = async (value) => {
    let id = "";
    id = value.id;
    // console.log(id)
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.MERCHANT_DISCOVERY_ADDRESS_DELETE + id,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          Authorization: "Bearer " + token,
        },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setCancelPopUp2(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantAddressList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

  const createNewAddressInputField = {
    shopName: {
      value: "",
      error: "",
    },
    address1: {
      value: "",
      error: "",
    },
    address2: {
      value: "",
      error: "",
    },
    postcode: {
      value: "",
      error: "",
    },
    state: {
      value: "",
      error: "",
    },
  };

  const createNewAddressInputText = {
    shopName: {
      placeholder: "Shop Name",
      required: "Shop Name is required",
      invalid: "Invalid Shop Name",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    address1: {
      placeholder: "Address 1",
      required: "Address 1 required",
      invalid: "Invalid Address 1",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    address2: {
      placeholder: "Address 2",
      required: "Address 2 required",
      invalid: "Invalid Address 2",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    postcode: {
      placeholder: "Postcode",
      required: "Postcode required",
      invalid: "Invalid Postcode",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    state: {
      placeholder: "State",
      required: "State required",
      invalid: "Invalid State",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
  };

  const errorMessageForMerchantAddress = (name, value) => {
    if (!value) {
      return createNewAddressInputText[name].required;
    } else if (!createNewAddressInputText[name].regex.test(value)) {
      return createNewAddressInputText[name].invalid;
    } else {
      return "";
    }
  };

  // const [createNewAddressInput, setCreateNewAddressInput] = useState();
  const [shopInput, setShopInput] = useState(createNewAddressInputField);

  useEffect(() => {
    setShopInput({
      shopName: merchantIds.name, 
      address1: merchantIds.address1 ,  
      address2: merchantIds.address2 ,  
      postcode: merchantIds.postcode ,  
      state: merchantIds.state ,        
    });
  }, [merchantIds]);

  const [shopNameValidate, setShopNameValidate] =
    useState("app-input-text");
  const [address1Validate, setAddress1Validate] =
    useState("app-input-text");
  const [address2Validate, setAddress2Validate] =
    useState("app-input-text");
  const [postcodeValidate, setPostcodeValidate] =
    useState("app-input-text");
  const [stateValidate, setStateValidate] =
    useState("app-input-text");

  const shopNameRef = useRef(null);
  const address1Ref = useRef(null);
  const address2Ref = useRef(null);
  const postCodeRef = useRef(null);

  useEffect(() => {
    if (shopNameRef.current && document.activeElement !== shopNameRef.current) {
      shopNameRef.current.focus();
    }
  }, [merchantIds.name]);

  useEffect(() => {
    if (address1Ref.current && document.activeElement !== address1Ref.current) {
      address1Ref.current.focus();
    }
  }, [merchantIds.address1]);

  useEffect(() => {
    if (address2Ref.current && document.activeElement !== address2Ref.current) {
      address2Ref.current.focus();
    }
  }, [merchantIds.address2]);

  useEffect(() => {
    if (postCodeRef.current && document.activeElement !== postCodeRef.current) {
      postCodeRef.current.focus();
    }
  }, [merchantIds.postcode]);

  const onHandleUpdateShopName = (newName) => {
    setMerchantId((prev) => ({ ...prev, name: newName }));
    setShopInput((prev) => ({
      ...prev,
      shopName: { ...prev.shopName, value: newName },
    }));
    setTimeout(() => {
      shopNameRef.current && shopNameRef.current.focus();
    }, 0);
  };

  const onHandleUpdateAddress1 = (newName) => {
    setMerchantId((prev) => ({ ...prev, address1: newName }));
    setShopInput((prev) => ({
      ...prev,
      address1: { ...prev.address1, value: newName },
    }));
    setTimeout(() => {
      address1Ref.current && address1Ref.current.focus();
    }, 0);
  };

  const onHandleUpdateAddress2 = (newName) => {
    setMerchantId((prev) => ({ ...prev, address2: newName }));
    setShopInput((prev) => ({
      ...prev,
      address2: { ...prev.address2, value: newName },
    }));
    setTimeout(() => {
      address2Ref.current && address2Ref.current.focus();
    }, 0);
  };

  const onHandleUpdatePostCode = (newName) => {
    setMerchantId((prev) => ({ ...prev, postcode: newName }));
    setShopInput((prev) => ({
      ...prev,
      postcode: { ...prev.postcode, value: newName },
    }));
    setTimeout(() => {
      postCodeRef.current && postCodeRef.current.focus();
    }, 0);
  };

  const onHandleUpdateState = (newName) => {
    setMerchantId((prev) => ({ ...prev, state: newName }));
    setShopInput((prev) => ({
      ...prev,
      state: { ...prev.state, value: newName },
    }));
  };

  const checkEmpty = (name, value) => {
    if (name === "shopName") {
      if (value === "") {
        setShopNameValidate("app-input-text-error");
      }
    }
    if (name === "address1") {
      if (value === "") {
        setAddress1Validate("app-input-text-error");
      }
    }
    if (name === "address2") {
      if (value === "") {
        setAddress2Validate("app-input-text-error");
      }
    }
    if (name === "postcode") {
      if (value === "") {
        setPostcodeValidate("app-input-text-error");
      }
    }
    if (name === "state") {
      if (value === "") {
        setStateValidate("app-input-text-error");
      }
    }
  };

  
  function PopupEditShopAddress(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              className="pop-up-button"
              style={{ marginRight: "10px" }}
              onClick={() => updateShopAddress(merchantIds)}
            >
              Update
            </button>
            <button
              className="pop-up-button"
              style={{ marginLeft: "10px" }}
              onClick={() => [setPopupEdit(false)]}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  const updateShopAddress = (value) => {
    let id = value.id;
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.MERCHANT_DISCOVERY_ADDRESS_UPDATE + id,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          name: shopInput.shopName,
          address1: shopInput.address1,
          address2: shopInput.address2,
          postcode: shopInput.postcode,
          state: shopInput.state,
        }),
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setPopupEdit(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantAddressList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

  const [paginationMerchantAddressLocker, setPaginationMerchantAddressLocker] =
    useState(true);

  const getMerchantAddressList = () => {
    const fetchData = async () => {
      let token = null;
      token = localStorage.getItem("@storage_token");
      try {
        let response = fetch(
          process.env.REACT_APP_API_URL +
            CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_DISCOVERY_ADDRESS_LIST + merchantId,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              "Accept-language": "en",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
              merchantDiscoveryId: merchantId,
              criteria: {
                keyword: "",
              },
              pageNumber: merchantAddressTable.pageNo,
              pageSize: merchantAddressTable.pageSize,
              sortDirection: merchantAddressTable.sortDir,
              sortKey: merchantAddressTable.sortBy,
            }),
          }
        )
          .then((response) => response.json())
          .then((json) => {
            let result = json;

            if (result.responseCode === 200) {
              setMerchantAddressList(result.result);
              setPaginationMerchantAddressLocker(false);
            } else {
              messageDialog({
                isOpen: true,
                condition: CONSTANSTS.DIALOG.failed,
                title: CONSTANSTS.DIALOG_TITLE.general_failed,
                message: response.message,
                defaultOnClick: false,
              });
            }
          });
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  };

  const getMerchantList = () => {
    const fetchMerchant = async () => {
      try {
        let token = null;
        let id = merchantId;
        let fetch_list_id = Number(merchantId) + 50;
        token = localStorage.getItem("@storage_token");
        // let response = fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/get/" + appId, {
        await fetch(
          process.env.REACT_APP_API_URL +
            CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_DISCOVERY_LIST,
           
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              "Accept-language": "en",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
              criteria: {
                dateFrom: "string",
                dateRangeType: null,
                dateTo: "string",
                keyword: "",
              },
              pageNumber: 1,
              pageSize: fetch_list_id,
              sortDirection: "ASCENDING",
              sortKey: "id",
            }),
          }
        )
          .then(function (response) {
            if (response.ok) {
              return response.json();
            } else {
              return;
            }
          })
          .then(function (data) {
            if (data !== null || data !== undefined) {
              let result = data.result;
              const foundMerchant = result.data.find(item => item.id == id)
              setMerchantName(foundMerchant.merchant_name)
            }
          });
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchMerchant();
  };

  const fetchState = async () => {
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION + "STATE", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        let res = json.result;
        setStateList(res);
      });
  };

  const merchantDiscoveryAddressesApproval = async (value, isApprove) => {
    console.log(
      "merchantDiscoveryAddressesApproval - param -",
      value,
      isApprove
    );
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.APPROVAL_MERCHANT_DISCOVERY_ADDRESS + "?addressId=" + value.id + "&isApprove=" + isApprove, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          // setCancelPopUp2(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantList();
          getMerchantAddressList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

  useEffect(() => {
    setShopInput(createNewAddressInputField);
    fetchState();
    getMerchantList();
    getMerchantAddressList();
  }, []);

  useEffect(() => {
    if (merchantAddressList?.data) {
      const autoExpanded = {};
      merchantAddressList.data.forEach((row, index) => {
        if (row.status === "PENDING_UPDATE") {
          autoExpanded[index] = true;
        }
      });
      // console.log("autoExpanded:", autoExpanded);
      setExpanded(autoExpanded);
    }
  }, [merchantAddressList]);

  const renderRowSubComponent = React.useCallback(
    ({ row }) => {
      const original = row.original;
      // console.log("SubComponent row:", original);
      if (original && original.status === "PENDING_UPDATE") {
        return (
          <div style={{ padding: "0px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr style={{ color: "red" }}>
                  <td style={{ minWidth: "320px", width:"200px" }}>
                    {original.tempName}
                  </td>
                  <td style={{ minWidth: "350px", width:"200px" }}>
                    {original.tempAddress1}
                  </td>
                  <td style={{ minWidth: "350px", width:"200px" }}>
                    {original.tempAddress2}
                  </td>
                  <td style={{ minWidth: "350px", width:"200px" }}>
                    {original.tempPostcode}
                  </td>
                  <td style={{ minWidth: "350px", width:"200px" }}>
                    {original.tempState}
                  </td>
                  <td style={{ minWidth: "350px", width:"200px" }}>
                  </td>
                  <td style={{ marginRight:"100px" }}> 
                    <button
                      onClick={() => [
                        merchantDiscoveryAddressesApproval(original, true),
                      ]}
                      className="react-table__search-button"
                      style={{ marginRight: "3px" }}
                    >
                      <IoCheckmark size={24} />
                    </button>
                    <button
                      onClick={() => [
                        merchantDiscoveryAddressesApproval(original, false),
                      ]}
                      className="react-table__search-button"
                    >
                      <IoClose size={24} />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }
      return null;
    },
    []
  );

  const nextMerchantAddressPage = async () => {
    if (
      merchantAddressList.currentPageNumber <
        merchantAddressList.totalPageNumber &&
      !paginationMerchantAddressLocker
    ) {
      setMerchantAddressTable({
        pageNo: merchantAddressTable.pageNo + 1,
        pageSize: merchantAddressTable.pageSize,
        sortBy: merchantAddressTable.sortBy,
        sortDir: merchantAddressTable.sortDir,
      });
      setPaginationMerchantAddressLocker(true);
    } else if (
      merchantAddressList.currentPageNumber ===
      merchantAddressList.totalPageNumber
    ) {
      setPaginationMerchantAddressLocker(false);
    }
  };

  const previousMerchantAddressPage = async () => {
    if (
      merchantAddressList.currentPageNumber > 1 &&
      !paginationMerchantAddressLocker
    ) {
      setMerchantAddressTable({
        pageNo: merchantAddressTable.pageNo - 1,
        pageSize: merchantAddressTable.pageSize,
        sortBy: merchantAddressTable.sortBy,
        sortDir: merchantAddressTable.sortDir,
      });
      setPaginationMerchantAddressLocker(true);
    } else if (merchantAddressList.currentPageNumber === 1) {
      setPaginationMerchantAddressLocker(false);
    }
  };

  const [cancelPopUp, setCancelPopUp] = useState(false);

  function PopupCreateNewAddress(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <button
              className="pop-up-button"
              style={{ marginRight: "10px" }}
              onClick={() => createNewAddress()}
            >
              Add
            </button>
            <button
              className="pop-up-button"
              style={{ marginLeft: "10px" }}
              onClick={() => [setCancelPopUp(false)]}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  // const [reactDate, setReactDate] = useState(new Date());

  const createNewAddress = () => {
    let id = merchantId;
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.MERCHANT_DISCOVERY_ADDRESS_CREATE + id,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          name: shopInput.shopName.value,
          address1: shopInput.address1.value,
          address2: shopInput.address2.value,
          postcode: shopInput.postcode.value,
          state: shopInput.state.value,
        }),
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setCancelPopUp(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantAddressList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

 
  const onHandleCreateShopName = (event) => {
    
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    shopInput.shopName.error = errorMessageForMerchantAddress(name, value);
    shopInput.shopName.value = value;
    checkEmpty(name, value);
    
  };

  const onHandleCreateAddress1 = (event) => {
    
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    shopInput.address1.error = errorMessageForMerchantAddress(name, value);
    shopInput.address1.value = value;
    checkEmpty(name, value);
    
  };

  const onHandleCreateAddress2 = (event) => {
    
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    shopInput.address2.error = errorMessageForMerchantAddress(name, value);
    shopInput.address2.value = value;
    checkEmpty(name, value);
   
  };
  
  const onHandleCreatePostcode = (event) => {
    
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    shopInput.postcode.error = errorMessageForMerchantAddress(name, value);
    shopInput.postcode.value = value;
    checkEmpty(name, value);
   
  };

  const onHandleCreateState = (event) => {
    
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    shopInput.state.error = errorMessageForMerchantAddress(name, value);
    shopInput.state.value = value;
    checkEmpty(name, value);
   
  };

  return (
    <div className="merchant-view">
      <div className="top-context">
        <div className="tabs">
          <div>
            <div
              className={"discover-tablinks " + tabCol1}
              onClick={() => tabClicked("1")}
            >
              <span>Merchant Discovery View</span>
            </div>
          </div>
          {tabCol1 === "tab-selected" &&
            accessMerchantAddress.create_merchant_address && (
              <div style={{ display: "flex" }}>
                <>
                  <div
                    className="search-button"
                    style={{ marginRight: "20px" }}
                  >
                    <AppButton
                      colorType="orange"
                      label="Add New Address"
                      onClick={() => setCancelPopUp(true)}
                      disabled={""}
                    ></AppButton>
                  </div>
                  <div className="search-button">
                    <AppButton
                      colorType="orange"
                      label="Cancel"
                      onClick={back}
                    ></AppButton>
                  </div>
                  <PopupCreateNewAddress trigger={cancelPopUp}>
                    <div className="popup-container">
                      <p className="popup-header">Add New Shop Address</p>
                      <form className="popup-form">
                        <div className="form-row">
                          <label>
                            <span>Shop Name:</span>
                          </label>
                          <input
                            type="text"
                            placeholder={
                              createNewAddressInputText.shopName.placeholder
                            }
                            className={shopNameValidate}
                            name="shopName"
                            onChange={onHandleCreateShopName}
                          />
                        </div>
                        <div className="form-row">
                          <label>
                            <span>Address 1:</span>
                          </label>
                          <input
                            type="text"
                            placeholder={
                              createNewAddressInputText.address1.placeholder
                            }
                            className={address1Validate}
                            name="address1"
                            onChange={onHandleCreateAddress1}
                          />
                        </div>
                        <div className="form-row">
                          <label>
                            <span>Address 2:</span>
                          </label>
                          <input
                            type="text"
                            placeholder={
                              createNewAddressInputText.address2.placeholder
                            }
                            className={address2Validate}
                            name="address2"
                            onChange={onHandleCreateAddress2}
                          />
                        </div>

                        <div className="form-row">
                          <label>
                            <span>Postcode:</span>
                          </label>
                          <input
                            type="text"
                            placeholder={
                              createNewAddressInputText.postcode.placeholder
                            }
                            className={postcodeValidate}
                            name="postcode"
                            onChange={onHandleCreatePostcode}
                          />
                        </div>

                        <div className="form-row">
                          <label>
                            <span>State:</span>
                          </label>
                          {stateList !== undefined ? (
                            <select
                              name="state"
                              id="state"
                              className={stateValidate}
                              style={{
                                display: "flex",
                                flex: 1,
                                height: "50px",
                              }}
                              onChange={onHandleCreateState}
                            >
                              <option value="">--State--</option>
                              {stateList
                                .sort((a, b) =>
                                  a.sortOrder > b.sortOrder ? 1 : -1
                                )
                                .map((d, i) => (
                                  <option value={d.label} key={i}>
                                    {d.label}
                                  </option>
                                ))}
                            </select>
                          ) : (
                            <select
                              name="state"
                              id="state"
                              className={stateValidate}
                              style={{ textAlign: "left" }}
                              onChange={onHandleCreateState}
                            >
                              <option value="">-- Category --</option>
                            </select>
                          )}
                        </div>
                      </form>
                    </div>
                  </PopupCreateNewAddress>
                  <PopupEditShopAddress trigger={PopupEdit}>
                  <div className="popup-container">
                      <p className="popup-header">Edit Shop Address</p>
                      <form className="popup-form">
                        <div className="form-row">
                          <label>
                            <span>Shop Name:</span>
                          </label>
                          <input
                            type="text"
                            ref={shopNameRef}
                            value={merchantIds.name}
                            className={shopNameValidate}
                            name="shopName"
                            onChange={(e) => onHandleUpdateShopName(e.target.value)}
                          />
                        </div>
                        <div className="form-row">
                          <label>
                            <span>Address 1:</span>
                          </label>
                          <input
                            type="text"
                            ref={address1Ref}
                            value={merchantIds.address1}
                            className={address1Validate}
                            name="address1"
                            onChange={(e) => onHandleUpdateAddress1(e.target.value)}
                          />
                        </div>
                        <div className="form-row">
                          <label>
                            <span>Address 2:</span>
                          </label>
                          <input
                            type="text"
                            ref={address2Ref}
                            value={merchantIds.address2}
                            className={address2Validate}
                            name="address2"
                            onChange={(e) => onHandleUpdateAddress2(e.target.value)}
                          />
                        </div>
                        <div className="form-row">
                          <label>
                            <span>Postcode:</span>
                          </label>
                          <input
                            type="text"
                            ref={postCodeRef}
                            value={merchantIds.postcode}
                            className={address2Validate}
                            name="postC"
                            onChange={(e) => onHandleUpdatePostCode(e.target.value)}
                          />
                        </div>
                        <div className="form-row">
                          <label>
                            <span>State:</span>
                          </label>
                          {stateList !== undefined ? (
                            <select
                              name="state"
                              id="state"
                              value={merchantIds.state}
                              className={stateValidate}
                              style={{
                                display: "flex",
                                flex: 1,
                                height: "50px",
                              }}
                              onChange={(e) =>
                                onHandleUpdateState(e.target.value)
                              }
                            >
                              <option value="">--State--</option>
                              {stateList
                                .sort((a, b) =>
                                  a.sortOrder > b.sortOrder ? 1 : -1
                                )
                                .map((d, i) => (
                                  <option value={d.label} key={i}>
                                    {d.label}
                                  </option>
                                ))}
                            </select>
                          ) : (
                            <select
                              name="state"
                              id="state"
                              className={stateValidate}
                              style={{ textAlign: "left" }}
                              onChange={(e) =>
                                onHandleCreateState(e.target.value)
                              }
                            >
                              <option value="">-- Category --</option>
                            </select>
                          )}
                        </div>
                      </form>
                    </div>
                 </PopupEditShopAddress>
                </>
              </div>
            )}
        </div>
      </div>
      <div className="merchant-detail-2">
        <div className={firstTab}>
          <div style={{ display: "inline", height: "37%", marginLeft: "10px" }}>
            <span style={{ fontFamily: "gotham-bold", fontSize: "22px" }}>
              Merchant Name: {merchantName}
            </span>
          </div>
          <div
            className="page-loan-application-list__react-table-wrapper"
            style={{ marginTop: "10px" }}
          >
            {accessMerchantAddress.list_merchant_address &&
            merchantAddressList !== undefined &&
            merchantAddressList.data !== undefined ? (
              <AppReactTable
                data={merchantAddressList.data || []}
                columns={merchantAddressTableColumn}
                expanded={autoExpanded}
                renderRowSubComponent={renderRowSubComponent}
                headerClass="userContractDetailsHeader"
                headerRowClass="userContractDetailsHeader__row"
                rowHeaderClass="userContractDetailsHeader__row-header"
                bodyClass="userContractDetailsBody"
                bodyRowClass="userContractDetailsBody__row"
                bodyDataClass="userContractDetailsBody__row-data"
              />
            ) : (
              <div></div>
            )}
          </div>
          <div className="pagination-button" style={{ float: "right" }}>
            {merchantAddressList !== undefined ? (
              <span>
                {tableSearchFilter.pageNo === 1 &&
                merchantAddressList.totalCount > 0
                  ? tableSearchFilter.pageNo
                  : tableSearchFilter.pageNo === 1 &&
                    merchantAddressList.totalCount === 0
                  ? merchantAddressList.totalCount
                  : 1 +
                    merchantAddressList.pageSize *
                      (merchantAddressList.currentPageNumber - 1)}{" "}
                - {""}
                {merchantAddressList.pageSize *
                  (merchantAddressList.currentPageNumber - 1) +
                  merchantAddressList.currentCount}{" "}
                of {merchantAddressList.totalCount}{" "}
              </span>
            ) : (
              <></>
            )}
            <button onClick={() => previousMerchantAddressPage()}>❮</button>
            <button onClick={() => nextMerchantAddressPage()}>❯</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageMerchantView;
